import React, { Component } from 'react';
import clsx from 'clsx';

import styles from './ContentRow.scss';

class ContentRow extends Component {
  static defaultProps = {
    withScroll: false,
    fullHeight: false,
  };

  render() {
    const { children, className, withScroll, fullHeight } = this.props;
    const css = clsx(className, {
      [styles.row]: true,
      [styles.withScroll]: withScroll,
      [styles.fullHeight]: fullHeight,
    });

    return <div className={css}>{children}</div>;
  }
}

export default ContentRow;
